<template>
  <div class="editPage">
    <qx-card :title="pageTitle">
      <BaseForm ref="baseForm" v-show="progressPamars.step === 1" />
      <NewMobile ref="newMobile" v-show="progressPamars.step === 2" />
    </qx-card>
    <SubBtnBox
      @sub="sub"
      :checkNextStep="true"
      v-model="progressPamars"
      @nextStep="nextStep"
    />
  </div>
</template>

<script>
import BaseForm from './base';
import NewMobile from './newMobile';
import SubBtnBox from './components/subBtnBox';
import {
  changeMobile,
  checkSmsCode,
} from 'api/user';
import pageDataMixin from '@qx/mixin/pageData';
import { removeToken, removeUserInfo } from '@qx/utils/auth';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    NewMobile,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/other/changeMobile',
      formComponents: ['baseForm', 'newMobile'],
      progressPamars: {
        step: 1,
      },
    };
  },
  methods: {
    editApi: changeMobile,
    async nextStep (step) {
      if (step === 1) {
        const formData = await this.$refs.baseForm.sub();
        if (formData) {
          const res = await checkSmsCode({
            phone: formData.oldPhone,
            verifyCode: formData.verifyCodeOrigin,
          });
          if (!res.failed && res !== 'N') {
            this.progressPamars.step++;
          } else if (!res.failed) {
            this.$message.error('短信验证码错误');
          }
        }
      } else {
        this.sub();
      }
    },
    handleSubSucc () {
      this.$message.success('修改成功');
      removeToken();
      removeUserInfo();
      this.$router.push({ path: '/login' });
    },
  },
};
</script>

<style scoped lang="scss">
</style>
